module.exports = __webpack_public_path__ + "img/03.4aa2d628.jpg";